import React from 'react';
import { IconProps } from './types';

const CustomUserIcon: React.FC<IconProps> = props => {
  const { fillColor = 'var(--greyscale-light)', width = 40, height = 40 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <rect width={width} height={height} rx="20" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 8.74991C22.7667 8.74991 25 10.9832 25 13.7499C25 16.5166 22.7667 18.7499 20 18.7499C17.2333 18.7499 15 16.5166 15 13.7499C15 10.9832 17.2333 8.74991 20 8.74991V8.74991ZM20 32.4166C15.8333 32.4166 12.15 30.2832 10 27.0499C10.05 23.7332 16.6667 21.9166 20 21.9166C23.3167 21.9166 29.95 23.7332 30 27.0499C27.85 30.2832 24.1667 32.4166 20 32.4166V32.4166Z"
        fill="var(--grayscale-content-3)"
      />
    </svg>
  );
};

export default CustomUserIcon;
